import React, { useEffect, useState } from 'react'
import AXIOSCONFIGMETHOD from '../../../../components/apiCall/axiosConfig';
import { webServiceUrl } from '../../../../components/apiCall/webserviceurl';
import Loading from '../../../../components/common/Loading';

function Accommodation_Info({ program_id }) {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
const local = localStorage.getItem("school_code");
  const getData = async () => {
    try {
      setLoading(true);
      const resp = await AXIOSCONFIGMETHOD("POST", webServiceUrl.accommodation_info, {
        "program_id": local
      })
      // console.log(resp?.data?.text?.split("/n/p"));
      setData(resp?.data);
    } catch (error) {
      console.error("Failed to fetch data", error);
    } finally {
      setTimeout(() => setLoading(false), 1000);
    }
  }

  useEffect(() => {
    getData()
  }, [])

  return (
    <div>
      {loading
        ? <div className="py-5" style={{ height: "20vh" }}><Loading /></div>
        : <>
          <section className="max-w-7xl mx-auto px-6 py-12">
            <p className="subHeading my-5">
              Accommodation
            </p>
            <div
              className="prose text-justify" // TailwindCSS class for justification
              dangerouslySetInnerHTML={{
                __html: data?.description?.trim() || ''
              }}
            />
            {/* 

<div className="heading">Key Features of TOP:</div>
<div
  className="prose text-justify" // TailwindCSS class for justification
  dangerouslySetInnerHTML={{
    __html: data?.key_features?.trim() || ''
  }}
/>
<div className="heading">Process Overview of TOP:</div>
<div
  className="prose text-justify" // TailwindCSS class for justification
  dangerouslySetInnerHTML={{
    __html: data?.process_overview?.trim() || ''
  }}
/> */}

          </section>
        </>}
    </div>
  )
}

export default Accommodation_Info
